import { useNavigate } from "react-router-dom";


import PromotionList from "../../features/promotion/promotionList";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import { Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

const ManagePromotion = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Promotion Management</h1>
        <p>
          <button
            onClick={() => navigate("/dashboard")}
          >
            Dashboard
          </button>{" "}
          - Promotion Management
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate('/manage-promotions/add')}><AddIcon /> Add Promotion</Button>
          </div>
        </div>
        <PromotionList />
      </div>
    </>
  );
};

export default ManagePromotion;
